import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Flex } from 'pcln-design-system'
import NavLink from '../NavLink'
import { headerLinkShape } from '../../utils/shapes'

const Container = styled(Flex)`
  display: flex;
  flex-direction: column;
`
Container.displayName = 'Container'

const Dropdown = styled(Flex)`
  display: flex;
  flex-direction: column;
  border-top: 1px solid lightgray;
  padding: ${themeGet('space.2')}px 0;

  background-color: ${props => props.backgroundColor || 'white'};
`
Dropdown.displayName = 'Dropdown'

const StyledNavLink = styled(NavLink)`
  width: 100%;
  padding: ${themeGet('space.3')}px;
`
StyledNavLink.displayName = 'StyledNavLink'

const StyledDropdownLink = styled(NavLink)`
  padding: ${themeGet('space.2')}px ${themeGet('space.4')}px;
`
StyledDropdownLink.displayName = 'StyledDropdownLink'

class SmallNavDropdown extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      isOpen: false
    }
  }

  onOpenToggle = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }))
  }

  render () {
    const {
      className,
      label,
      target,
      iconName,
      color,
      iconColor,
      backgroundColor,
      links
    } = this.props

    const { isOpen } = this.state
    const dropdownIconName = isOpen ? 'ChevronUp' : 'ChevronDown'

    return (
      <Container className={className}>
        <StyledNavLink
          label={label}
          iconName={iconName}
          dropdownIconName={dropdownIconName}
          color={color}
          iconColor={iconColor}
          onClick={this.onOpenToggle}
        />
        {isOpen && (
          <Dropdown backgroundColor={backgroundColor}>
            {links &&
              links.length > 0 &&
              links.map(link => (
                <StyledDropdownLink
                  key={link.label}
                  {...link}
                  target={target}
                  color={color}
                  iconColor={iconColor}
                />
              ))}
          </Dropdown>
        )}
      </Container>
    )
  }
}

SmallNavDropdown.displayName = 'SmallNavDropdown'

SmallNavDropdown.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  target: PropTypes.string,
  iconName: PropTypes.string,
  color: PropTypes.string,
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  links: PropTypes.arrayOf(headerLinkShape).isRequired
}

SmallNavDropdown.defaultProps = {
  className: ''
}

export default SmallNavDropdown
